<template>
    <div>
        <h4>Vue Chapter 3</h4>
        <p>テスト用、、、。</p>
    </div>
</template>

<script>
    export default{
        name: 'VueChapter3',
    }
</script>